window.addEventListener("DOMContentLoaded", () => {
  /* Accordion */
  const matches = document.querySelectorAll(
    ".wp-block-makimo-blocks-accordion, .makimo-blocks-accordion"
  );

  matches.forEach((item) => {
    const clickable = item.querySelectorAll("h3, svg");

    clickable.forEach((elem) => {
      elem.addEventListener("click", () => {
        matches.forEach((item) => {
          item.classList.remove("open");
        });

        item.classList.toggle("open");

        window.scroll({
          top: item.offsetTop,
          left: 0,
          behavior: "smooth",
        });
      });
    });
  });

  /* Snap scroller */
  document.querySelectorAll(".snap-scroller").forEach((item) => {
    const container = item.querySelector(".snap-container");
    const controls = item.querySelector(".snap-controls");

    const leftArrow = controls.querySelector(".left");
    const rightArrow = controls.querySelector(".right");
    const progressBar = controls.querySelector(".progress");

    const scrollBy = Math.trunc(
      container.scrollWidth / container.childElementCount
    );

    controls.classList.toggle(
      "visible",
      container.scrollWidth > container.clientWidth
    );

    leftArrow.addEventListener("click", () => container.scrollBy(-scrollBy, 0));
    rightArrow.addEventListener("click", () => container.scrollBy(scrollBy, 0));

    const updateScrollStatus = () => {
      const scrollPercentage = Math.round(
        (container.scrollLeft /
          (container.scrollWidth - container.clientWidth)) *
          100
      );

      controls.classList.toggle(
        "visible",
        container.scrollWidth > container.clientWidth
      );

      leftArrow.classList.toggle("inactive", scrollPercentage === 0);
      rightArrow.classList.toggle("inactive", scrollPercentage === 100);

      progressBar.style.setProperty("--percentage", `${scrollPercentage}%`);
    };

    container.addEventListener("scroll", updateScrollStatus);
    window.addEventListener("resize", updateScrollStatus);
  });

  /* Work around service menu chevron click action */
  window.addEventListener("load", () => {
    document.querySelectorAll("#menu-item-4773").forEach((el) => {
      el.addEventListener("click", (event) => {
        const path = event.composedPath();

        // If a sub-item link was clicked, pass the event as normal
        for (let i = 0; i < path.length; i++) {
          if (
            path[i].nodeName === "A" &&
            path[i].getAttribute("href") !== "#"
          ) {
            return;
          }
        }

        document.querySelector(".mobile-menu li .chevron").click();
        event.preventDefault();
      });
    });
  });
});
